module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?8ced95a05e3c82d7b6ef6cd3f31c7ccb";